import { WPInputHelperText } from "./WPInputHelperText";

export default WPInputHelperText;
